import styled from "styled-components";
import Variables from "../../../assets/styleVariables";

export const AddContainer = styled.div`
	${props => props.disable && `opacity: 0.6;`}	
	position: absolute;
	top: 85px;
	right: 16px;
	padding: 17px 16px 0 0;
	height: 88px;
	${props => {
    if (props.expand) {
      return ` width: 100%; `;
    } else {
      return `
				width: 79px;
				span.list-item-text {
					display: none;
				}
			`;
    }
  }}
	margin-top: -20px;
	border-top: 0;
	border-right: 0;
	border-left: 0;
	${props => {
    if (props.hasShadow) {
      return `box-shadow: 0 2px 3px 0px #CCCCCC;`;
    }
  }}
	background-color: ${Variables.colors.complementary};
	direction: rtl;
	text-align: right;
	z-index: 1;
	.add-button {
		cursor: pointer;
		display: inline-flex;
		justify-content: flex-start;
		align-items: center;
		box-shadow: 0 0 6px 0 #CCCCCC;
		
		${props => {
			if (props.expand) {
				return `
					min-width: 170px;
					height: 48px;
					border-radius: 32px;
				`;
      } else {
        return `
					width: 46px;
					height: 46px;
					border-radius: 50%;
				`;
      }
    }}

		.add-button-text {
			margin-left: 15px;
			${props => {
        if (props.expand) {
          return `display: block;`;
        } else {
          return `display: none;`;
        }
      }}
		}
		${props =>
      !props.disable &&
      `&:hover {
				${props => {
          if (props.status) {
            return `box-shadow: unset;`;
          } else {
            return `box-shadow: 0 2px 12px 0 #CCCCCC;`;
          }
        }}
				background-color: ${Variables.colors.complementary_200};
			}`}
		${props => {
      if (props.status) {
        return `box-shadow: unset;`;
      }
    }}
		padding: 17px 0 17px 0;
		font-size: ${Variables.font_sizes.x_medium};
		font-weight: ${Variables.font_weight.medium};
		color: ${Variables.colors.complementary_900};
		.button-text {
			z-index: 9999;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			border-radius: 32px;
			background-color: ${Variables.colors.complementary};
			${props => {
        if (props.expand) {
          return `
						width: auto;
						height: auto;
						position: static;
						padding-right: 14px;
						right: unset;
					`;
        } else {
          return `
						width: 47px !important;
						height: 47px !important;
						position: relative;
						padding-right: 14px;
						right: 0;
					`;
        }
      }}
			${props =>
        !props.disable &&
        `&:hover {
					background-color: ${Variables.colors.complementary_200};
				}`}
			
			${props => {
        if (props.status) {
          return `
						box-shadow: 0 0 2px 0 #CCCCCC;
						border-radius: 32px;
						position: absolute;
						right: 14px;
						top: 16px;
						padding-right: 15px;
					`;
        }
      }}
			
			min-width: 170px;
    	height: 48px;
			
			i, span {
				z-index: 9999;
			}
			i.mapsa-plus {
				&:before {
					margin-left: 10px;
					color: ${Variables.colors.primary_vivid};
				}
			}
			i.mapsa-arrow {
				transform: ${props => (props.status ? "rotate(90deg)" : "rotate(-90deg)")};
        margin-right: ${props => (props.expand ? "" : "8px")};
        font-size:8px;
				&:before {
					color: ${Variables.colors.complementary_800};
					margin: 0;
				}				
			}
		}
	}
	.expandable {
		${props => {
      if (props.expand) {
        return `
					padding-right: 158px;
				`;
      } else {
        return `
					padding-right: 65px;
				`;
      }
    }}
		min-width: 712px;
		height: 48px;
		z-index: 9999;
		position: fixed;
		top: 80px;
		box-shadow: 0 2px 14px 0 #CCCCCC;
		border-radius: 32px;
		padding-left: 18px;
		background-color: ${Variables.colors.complementary};
		cursor: auto;
		${props => {
      if (!props.status) {
        return `
					display: none;
					right: 38px;
					width: 0;`;
      } else {
        if (props.expand) {
          return `
						right: 37px;
						@media (max-width: 1199px) {
							right: 22px;
						}
					`;
        } else {
          return `
						right: 25px;
					`;
        }
      }
    }}
		ul {
			padding: 6px 0 0 0 !important;
			margin: 0 !important;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.addButtonSeparator {
				background-color: ${Variables.colors.complementary_700};
				height: 26px;
				width: 1px;
				margin: 0 9px;
			}
			a {
				font-size: ${Variables.font_sizes.medium};
				color: ${Variables.colors.complementary_900};
				text-decoration: none;
				&:visited, &:hover, &:active {
					color: ${Variables.colors.complementary_900};
				}
				li {
					display: flex;
					align-items: center;
					padding: 8px 12px;
					margin: 0;
					list-style: none;
					height: 36px;
					min-width: 99px;
					cursor: pointer;
					border-radius: 4px;
					&:last-child {
						border-left: 0;
					}
					span {
						font-size: ${Variables.font_sizes.medium};
						color: ${Variables.colors.complementary_900};
						font-weight: ${Variables.font_weight.regular};
					}
					&:hover {
						height: 36px;
						min-width: 99px;
						border-radius: 4px;
						background-color: ${Variables.colors.primary_50};
						span, i:before {
							color: ${Variables.colors.primary_vivid};
						}
					}
				}
			}
			i:before {
				color: ${Variables.colors.complementary_800};
				font-size: 16px;
				margin-left: 12px;
			}
		}
	}
	@media (max-width: 1199px) {
		${props => {
      if (!props.expand) {
        return `
					.add-button-text {
						display: none !important;
					}
					.add-button {
						width: 46px;
						height: 46px;
						border-radius: 50%;
						.button-text {
							width: 47px;
							height: 47px;
							position: relative;
							padding-right: 14px;
							right: -1px;
							top: -3px;
							i.mapsa-arrow {
								margin-right: 10px;
							}
						}
					}
					.expandable {
						padding-right: 65px;
						top: 78px;
					}	
				`;
      }
    }}
	}
`;
